import { render, staticRenderFns } from "./HorizontalNavMenu.vue?vue&type=template&id=1c05fda4"
import script from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenu.vue?vue&type=style&index=0&id=1c05fda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports